import React from 'react';
import Header from './components/Header';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import CareersPage from './components/Careers';
import Certificate from './components/Certificate';
import About from './components/About';

import Contact from './components/ContactForm';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Header />
      <Navbar />
      <HeroSection />
     
      <Services /> 
      <CareersPage/>
      <Certificate/>
       <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
